import React ,{useState,useEffect }from "react";
import {NavLink} from 'react-router-dom';
import './About.css';
import img2 from './Aboutimg/aboutimg2.webp'
import img3 from './Aboutimg/aboutimg3.webp'
import img4 from './Aboutimg/aboutimg4.webp'
import img5 from './Aboutimg/aboutimg5.webp'
import img6 from './Aboutimg/aboutimg6.JPG'
import img7 from './Aboutimg/aboutimg7.webp'
import img8 from './Aboutimg/aboutimg8.webp'
import Abs from './Absection'
// import video1 from './video1.mp4'
import video2 from './video2.mp4'
import Gallery from './Gallery'
import { UserAuth } from "../Login/AuthContext";
function About(){
    const scrolltop = () =>{
        window.scrollTo({top:0});
    };
    const [isShownHoverContent, setIsShownHoverContent] = useState(false);
    const [isShownHoverContent1, setIsShownHoverContent1] = useState(false);
    const [isShownHoverContent2, setIsShownHoverContent2] = useState(false);
    const [isShownHoverContent3, setIsShownHoverContent3] = useState(false);
    const [isShownHoverContent4, setIsShownHoverContent4] = useState(false);
    const [isShownHoverContent5, setIsShownHoverContent5] = useState(false);
    const { user, logout } = UserAuth();

    useEffect(() => {
        logout();
   }, [])
 
return (
 
  <div className="aboutwrapper">
      <div className="about-top">
            {/* <div className="about-top-title">Broad-Ocean’s Mission</div>
            <div className="about-top-text">Focus on green and environmentally friendly solutions in the field of motors and drive systems, customer first, innovation driven, open cooperation, realize value for our customers, investors, employees and other partners, surpass ourselves, and faithfully fulfill social responsibilities</div> */}
            {/* <Abs/>   */}

      </div>
      <div className="about-section">
        <div className="about-inner">
        <div className="about-title">About Broad-Ocean Motor Group</div>
        <div className="about-overview">
        <div className="about-overview-right">
            {/* <img className="about-overview-img1" src={img8}/> */}
            <video className="about-overview-video" src={video2}  controls="controls" />
            </div>
            <div className="about-overview-left">
               
                <div>&nbsp;</div>
                <div className="about-overview-text">Broad-Ocean Motor Group (BOMG), headquartered in China, Is a leading global supplier of high-efficiency motors and electric drive systems,
covering building and home appliance motors; starters and alternators, as well as powertrain systems and key components for new energy vehicles (NEVs). In recent years,
in observation of opportunities arising from the deep electrification and automation trend and
AI applications, including those in relation to the robotic, HVAC, NEVs and fuel cell industries,
we have been steadily exploring related market sectors, such as clean energy generation and
integrated thermal energy utilization equipment, achieving industry-leading technology
breakthroughs in critical domains and a successful track record of commercialization, thereby
laying a solid foundation for sustainable future growth.
</div>
                <div>&nbsp;</div>
                <div className="about-overview-text">BOMG maintains independent R&D in core technologies, operating 9 R&D centers across China 、 the United States and UK, along with a postdoctoral research workstation and an expert workstation. The company has filed more than 4,500 patents. To strengthen its global footprint, BOM operates 21 sales and manufacturing bases worldwide. Annual shipments exceed 80 million units, serving customers in more than 80 countries and regions.</div>
                <div>&nbsp;</div>
                <div className="about-overview-text">BOMG has a significant presence in North America, comprising:</div>
                <div className="about-overview-text">•	A manufacturing base in Monterrey, Mexico (Broad-Ocean Motor de Mexico)</div>
                <div className="about-overview-text">•	A manufacturing base in Indianapolis, IN (Broad-Ocean Motor Indiana)</div>
                <div className="about-overview-text">•	A distribution center in Houston, TX (Broad-Ocean Motor Houston)</div>
                <div className="about-overview-text">•	A research & engineering center in Detroit, MI (Broad-Ocean Technologies, LLC)</div>
                <div className="about-overview-text">•	A customer technical support and business development office in Chicago, IL.</div>
                <div>&nbsp;</div>
                <div className="about-overview-text">Detailed introductions to each North American subsidiary follow in the next section. Business Scope:</div>
                <div className="about-overview-text">•	Building & home appliance motors: commercial air conditioners; residential air conditioners; automatic garage doors; pumps; ventilation equipment</div>
                <div className="about-overview-text">•	NEV powertrains: hydrogen fuel cells and key components; electric drive systems for NEVs; BSG systems</div>
                <div className="about-overview-text">•	Vehicle rotating electricals: alternators and starters for on-road vehicles and off-road machinery; passenger-vehicle alternators and starters</div>
            </div>
           

        </div>

        </div>

      </div>
      <div className="about-section">
            <div className="about-inner">
            <div className="about-title">Our Initiatives</div>
            <div className="about-mid-block">
                <div className="about-mid-left"
                onMouseEnter={() => setIsShownHoverContent(true)}
                onMouseLeave={() => setIsShownHoverContent(false)}
                
                >   
                <img className="about-init-img" src={img2}/>
                {isShownHoverContent && (
                <div className="about-hover">
                    
                     <div className="university-left">
            <div className="about-hover-title">University Outreach</div>
            <div className="about-hover-text">
We are looking for talent from University of Michigan and Wayne State University with an interest in participating in advanced engineering research projects.</div>
            <button className="about-hover-button"><NavLink to='/University' onClick={scrolltop}>Learn More</NavLink></button>
                </div>
                </div>
                     )}


                </div>

                <div className="about-mid-right"
                onMouseEnter={() => setIsShownHoverContent1(true)}
                onMouseLeave={() => setIsShownHoverContent1(false)}
                
                >   
                <img className="about-init-img" src={img3}/>
                {isShownHoverContent1 && (
                <div className="about-hover">
                      <div className="university-right">
            <div className="about-hover-title">Department of Energy Standards</div>
            <div className="about-hover-text">Broad-Ocean Motor is on the forefront of industry energy efficiency efforts and develops motors that meet or exceed legislative requirements</div>
            
            <button className="about-hover-button"><a href="https://www1.eere.energy.gov/buildings/appliance_standards/standards.aspx?productid=6&action=viewlive">Learn More</a></button>
            </div>
                </div>
                     )}


                </div>
            </div>
            </div>
      </div>

<div className="about-section">
      <div className="about-inner">
      <div className="about-title">Our Culture </div>
        <Gallery/>
        
        </div>
      </div>
      <div className="about-section ">
      
            <div className="about-inner">
            <div className="about-title">Our Locations</div>
            <div className="about-mid-block">
                <div className="about-mid-left"
                onMouseEnter={() => setIsShownHoverContent2(true)}
                onMouseLeave={() => setIsShownHoverContent2(false)}
                
                >   
                <img className="about-location-img" src={img4}/>
                {isShownHoverContent2 && (
                    <NavLink to='/Mic' onClick={scrolltop}>
                <div className="about-hover">
                    
                     <div className="about-location-left">
            <div className="about-location-title">Broad-Ocean Technologies</div>
            <div className="about-location-text">Research & Development</div>
            
                </div>
                </div>
                </NavLink>
                     )}


                </div>

                <div className="about-mid-right"
                onMouseEnter={() => setIsShownHoverContent3(true)}
                onMouseLeave={() => setIsShownHoverContent3(false)}
                
                >   
                <img className="about-location-img" src={img5}/>
                {isShownHoverContent3 && (
                    <NavLink to='/Hou' onClick={scrolltop}>
                <div className="about-hover">
                      <div className="about-location-right">
            <div className="about-location-title">Broad-Ocean Motor Houston</div>
            <div className="about-location-text">Testing & Distribution</div>
            
            
            </div>
                </div>
                </NavLink>
                     )}


                </div>
            </div>


            <div className="about-mid-block">
                
                <div className="about-mid-left"
                onMouseEnter={() => setIsShownHoverContent4(true)}
                onMouseLeave={() => setIsShownHoverContent4(false)}
                
                >   
                <img className="about-location-img" src={img6}/>
                {isShownHoverContent4 && (
                    <NavLink to='/Ind' onClick={scrolltop}>
                <div className="about-hover">
                    
                     <div className="about-location-left">
            <div className="about-location-title">Broad-Ocean Motor Indiana</div>
            <div className="about-location-text">Testing & Distribution</div>
            
                </div>
                </div>
                </NavLink>
                     )}


                </div>

                <div className="about-mid-right"
                onMouseEnter={() => setIsShownHoverContent5(true)}
                onMouseLeave={() => setIsShownHoverContent5(false)}
                
                >   
                <img className="about-location-img" src={img7}/>
                {isShownHoverContent5 && (
                    <NavLink to='/Mx' onClick={scrolltop}>
                <div className="about-hover">
                      <div className="about-location-right">
            <div className="about-location-title">Broad-Ocean Motor Mexico</div>
            <div className="about-location-text">Distribution</div>
            
            
            </div>
                </div>
                </NavLink>
                     )}


                </div>
            </div>


        </div>
      </div>




  </div>





);




}
export default About;